import type { Questionnaire } from '@medplum/fhirtypes'

export const SocialHistoryQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/demographics-social-history',
  status: 'draft',
  subjectType: ['Patient'],
  name: 'Social History Demographics',
  title: 'Social History',
  item: [
    {
      linkId: 'religion',
      text: 'Religion',
      type: 'string',
    },
    {
      linkId: 'place-of-worship',
      text: 'Place of Worship',
      type: 'string',
    },
    {
      linkId: 'education',
      text: 'Education',
      type: 'choice',
      answerOption: [
        {
          valueCoding: {
            code: 'no-formal-education',
            display: 'No formal education',
          },
        },
        {
          valueCoding: {
            code: 'primary-education',
            display: 'Primary education',
          },
        },
        {
          valueCoding: {
            code: 'secondary-education',
            display: 'Secondary education',
          },
        },
        {
          valueCoding: {
            code: 'tertiary-education',
            display: 'Tertiary education',
          },
        },
      ],
    },
    {
      linkId: 'occupation',
      text: 'Occupation',
      type: 'string',
    },
    {
      linkId: 'english-fluency',
      text: 'English Fluency',
      type: 'choice',
      answerOption: [
        {
          valueCoding: {
            code: 'native-speaker',
            display: 'Native speaker',
          },
        },
        {
          valueCoding: {
            code: 'fluent',
            display: 'Fluent',
          },
        },
        {
          valueCoding: {
            code: 'intermediate',
            display: 'Intermediate',
          },
        },
        {
          valueCoding: {
            code: 'beginner',
            display: 'Beginner',
          },
        },
      ],
    },
    {
      linkId: 'military-service',
      text: 'Military Service',
      type: 'boolean',
    },
    {
      linkId: 'living-situation',
      text: 'Living Situation',
      type: 'choice',
      answerOption: [
        {
          valueCoding: {
            code: 'independent',
            display: 'Living independently',
          },
        },
        {
          valueCoding: {
            code: 'with-family',
            display: 'Living with family',
          },
        },
        {
          valueCoding: {
            code: 'assisted-living',
            display: 'Assisted living facility',
          },
        },
        {
          valueCoding: {
            code: 'nursing-home',
            display: 'Nursing home',
          },
        },
        {
          valueCoding: {
            code: 'homeless',
            display: 'Homeless',
          },
        },
      ],
    },
    {
      linkId: 'preferred-funeral-home',
      text: 'Preferred Funeral Home',
      type: 'string',
    },
  ] as const,
} satisfies Questionnaire
